// 主题色变量参考 https://3x.antdv.com/docs/vue/customize-theme-cn
export default {
    primaryColor: "#1677FF",
    linkColor: "#1677FF"
}
